import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Button } from 'primereact/button';
import {InputTextarea} from 'primereact/inputtextarea';
import Loader from '../sturtural/Loader';
import { storage } from '../../helpers/storage';

let initObservation = {
    text: ''
};

const HeaderFinaliceValidation = ({solicitud, title }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const [finalice, setFinalice] = useState(false);
    const [displayConfirmation, setDisplayConfirmation] = useState(false);
    const [displayObservation, setDisplayObservation] = useState(false);
    
    const [loadconfirm, setLoadConfirm] = useState(false);
    const [loadFinalice, setLoadFinalice] = useState(false);

    const [response, setResponse] = useState(false);
    const [mesaje, setMesaje] = useState(false);
    const [redirect, setRedirect] = useState(false);

    const [observation, setObservation] = useState(initObservation);
    const [submitted, setSubmitted] = useState(false);

    let url = `${BASE_API}demand/edit/${solicitud}`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*'
            }
        }).then(res => { 
            if(res.response === 'on') {
                let demand = res.demand;
                setData(demand);
                setError(false); 

                if([9, 14].includes(demand.statusid)) {
                    setFinalice(true);
                }
            } else if(res.response === 'off') {
                setError(true);
            }
            setLoading(false); 
        });
    }, [url]);
    
    const handleConfirmation = () => {
        setLoadConfirm(true);
        helpHttp().get(`${BASE_API}demand/validation/status/${solicitud}`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                "Access-Control-Allow-Origin": '*',
                "x-access-token": storage.get('token')
            },
        }).then(res => { 
            if(res.response === 'on') {
                if(res.status === 1) {
                    setResponse(true);
                } else if(res.status === 2 || res.status === 3) {
                    setDisplayConfirmation(true);
                } 
                setMesaje(res.message);
                setError(false); 

                // if(res.terminalodo) {
                //     console.g('terminado');
                //     setRedirect(true);
                // }
                setLoadConfirm(false); 
            } else if(res.response === 'off') {
                setError(true);
            }
        });
    }

    const handleFinaticeValidation = () => {

        const arrSet = {
            solicitudid: solicitud
        }

        helpHttp().put(`${BASE_API}demand/validation/finalice`, {
            body: arrSet,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*',
                'x-access-token': storage.get('token')
            },
        }).then(res => { 
            if(res.response === 'on') {
               // let demand = res.demand;
                setLoadFinalice(false); 
                setDisplayConfirmation(false);
                setResponse(true);
                setMesaje(res.message);
                setError(false); 

                if(res.terminado) {
                    console.log('terminado');
                    setRedirect(true);
                }
            } else if(res.response === 'off') {
                setError(true);
            }
            
        });
    }

    const handleModalObservation = () => {
        setDisplayConfirmation(false);
        setDisplayObservation(true);
    }

    const saveObservation = () => {

        setSubmitted(true);

        if (observation.text.trim()) {

            const arrSet = {
                solicitudid: solicitud,
                text: observation.text.toUpperCase().trim()
            }
            
            helpHttp().put(`${BASE_API}demand/validation/observation`, {
                body: arrSet,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Access-Control-Allow-Origin': '*',
                    'x-access-token': storage.get('token')
                },
            }).then(res => { 
                if(res.response === 'on') {
                   // let demand = res.demand;
                    setLoadFinalice(false); 
                    setDisplayConfirmation(false);
                    setResponse(true);
                    setMesaje(res.message);
                    setError(false); 
    
                    if(res.terminado) {
                        console.log('terminado');
                        setRedirect(true);
                    }
                } else if(res.response === 'off') {
                    setError(true);
                }
                
            });
        }
    }

    const handlerRedirect = () => {
        if(redirect) {
            window.location.href = "/#/lista-solicitudes-registro";
        } else {
            setResponse(false);
        }
    }

    const confirmationDialogFooter = (
        <>
            <Button type="button" label="Observación" icon="pi pi-tag" onClick={handleModalObservation} className="p-button-text" />
            <Button type="button" label="Finalizar +" disabled={loadFinalice} icon="pi pi-lock" onClick={handleFinaticeValidation} className="p-button-text" autoFocus />
        </>
    );

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={handlerRedirect} icon="pi pi-check" className="p-button-secondary" />;

    const observationDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={() => setDisplayObservation(false)} />
            <Button label="Finalizar -" icon="pi pi-lock" className="p-button-text" onClick={saveObservation} />
        </>
    );

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _observation = { ...observation };
        _observation[`${name}`] = val;

        setObservation(_observation);
    }

    return (
        <>
            {loading && <Loader /> }
            {!error &&
            <div className="card">
                <div className="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
                    <div>
                        <div className="font-medium text-3xl text-900">{title}</div>
                        <div className="flex align-items-center text-700 flex-wrap">
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>
                                    {data.nombre} {data.apellido1} {data.apellido2}
                                </span>
                            </div>
                            <div className="mr-5 flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.curp}</span>
                            </div>
                            <div className="flex align-items-center mt-3">
                                <i className="pi pi-check-circle mr-2"></i>
                                <span>{data.correo_electronico}</span>
                            </div>
                        </div>
                    </div>
                    {finalice &&
                        <div className="mt-3 lg:mt-0">
                            {loadconfirm && <Loader rem='2rem' />}
                            <Button label="Finalizar proceso" disabled={loadconfirm} icon="pi pi-check" onClick={handleConfirmation} />
                        </div>
                    }
                </div>
                
                <Dialog header="Confirmación" visible={displayConfirmation} onHide={() => setDisplayConfirmation(false)} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationDialogFooter}>
                    <div className="flex align-items-center justify-content-center">
                        {loadFinalice ? <Loader rem='2rem' /> : <i className="pi pi-exclamation-circle mr-3" style={{ fontSize: '2rem' }} />}
                        <span>
                            Es importante que se asegure de contar con todos los documentos requeridos para la aprobación de esta solicitud.<br /><br />
                            Al finalizar esta acción se le enviará un correo electrónico al solicitante, con el resultado de su validación, ya sea con documentos rechazados o con los documentos ya aprobados.<br /><br />
                            {mesaje && <><strong>{mesaje}</strong><br /><br /></>}
                            
                            Si desea realizar una observación a esta solicitud, seleccione el botón "Observación" y si no, seleccione el botón "Finalizar"
                        </span>
                    </div>
                </Dialog>

                <Dialog header="Aviso" visible={response} style={{ width: '30vw' }} modal className="p-fluid" footer={basicDialogFooter}>
                    <p>{mesaje}</p>
                </Dialog>

                <Dialog visible={displayObservation} style={{ width: '450px' }} header="Observación" modal className="p-fluid" footer={observationDialogFooter} onHide={() => setDisplayObservation(false)}>
                    <div className="field">
                        <label htmlFor="text">Escriba la observación que desee enviar al solicitante:</label>
                        <InputTextarea id="text" value={observation.text.toUpperCase()} onChange={(e) => onInputChange(e, 'text')} required rows={3} cols={20} />
                        {submitted && !observation.text && <small className="p-error">El Campo (Observación) es requerido.</small>}
                    </div>
                </Dialog>
            </div>
            }
        </>
    );
}

export default HeaderFinaliceValidation;